module.exports = __webpack_public_path__ + "static/media/pt.782d1aa3.svg";